import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { COLORS } from '../constants/colors';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 24px;
  color: #333;
`;

const Section = styled.section`
  margin-bottom: 32px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 16px;
  color: #495057;
`;

const Text = styled.p`
  line-height: 1.6;
  color: #666;
  margin-bottom: 12px;
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin: 16px 0;
`;

const EmailLink = styled.a`
  color: ${COLORS.PRIMARY};
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const ContactPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <Container>
      <Title>{t('contact.title')}</Title>
      
      <Section>
        <SectionTitle>{t('contact.generalInquiries')}</SectionTitle>
        <Text>{t('contact.description')}</Text>
        
        <ContactInfo>
          <Text><strong>{t('contact.email')}:</strong> <EmailLink href="mailto:contact@storify-now.com">contact@storify-now.com</EmailLink></Text>
          <Text><strong>{t('contact.responseTime')}:</strong> {t('contact.responseTimeValue')}</Text>
        </ContactInfo>
      </Section>

      <Section>
        <SectionTitle>{t('contact.companyInfo')}</SectionTitle>
        <Text><strong>{t('contact.companyName')}:</strong> CC VALUE SRL</Text>
        <Text><strong>{t('contact.address')}:</strong> sat Valea Seaca, comuna Baltatesti, strada Vadului, nr. 102A, judet Neamt, Romania</Text>
        <Text><strong>{t('contact.registrationNumber')}:</strong> RO45935213</Text>
        {/* <Text><strong>{t('contact.vatNumber')}:</strong> [Your VAT Number]</Text> */}
      </Section>

      <Section>
        <SectionTitle>{t('contact.dataProtection')}</SectionTitle>
        <Text>{t('contact.dataProtectionText')}</Text>
        <Text><strong>{t('contact.dpo')}:</strong> <EmailLink href="mailto:contact@storify-now.com">contact@storify-now.com</EmailLink></Text>
      </Section>
    </Container>
  );
};